import React from 'react';

import { DataDisputeReportInfoFragment, DataDisputeWhere } from 'src/api';
import { Table, TableColumn } from 'src/components/table';
import { useFilterStorage, useSearch } from 'src/hooks/common';
import { useDataDisputeReportList, useDataDisputeReportTableRowActions } from 'src/hooks/reports';

interface DataDisputeReportInnerTableProps {
  columns: Array<TableColumn<DataDisputeReportInfoFragment>>;
  filter?: DataDisputeWhere;
}

export const DataDisputeReportInnerTable: React.FC<DataDisputeReportInnerTableProps> = ({
  columns,
  filter,
}) => {
  const { dataDisputeReportList, dataDisputeReportListCount, loading } = useDataDisputeReportList({
    filter,
  });

  const rowActions = useDataDisputeReportTableRowActions();

  const { setSearchValue, searchValue } = useSearch();
  const { pagination, setSortOption } = useFilterStorage();

  // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect must not depend on "pagination" here
  React.useEffect(() => {
    pagination.resetPage();
  }, [searchValue]);

  return (
    <Table
      dataSource={dataDisputeReportList}
      rowCount={dataDisputeReportListCount}
      columns={columns}
      rowActions={rowActions}
      pagination={pagination}
      onSearch={setSearchValue}
      onSort={setSortOption}
      loading={loading}
    />
  );
};
